export default __webpack_public_path__ + "static/on-track-mobile-7650c682f0a2b99aa4f8a0cd918af2ca.svg";